import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";
import tokenMiddleware from "./middleware";
import createAPIClient from "../api";
import {
  cartReducer,
  authReducer,
  checkoutReducer,
  uiReducer,
  contactReducer
} from "./reducers";

const isDev =
  process.env.NODE_ENV !== "development" || process.env.NODE_ENV !== "test";

const initialState = {
  ui: {
    showUVP: true,
    showPrice: true
  },
  contact: {
    contactStatus: {
      indication: null,
      error: {
        status: null,
        message: null
      }
    }
  },
  cart: {
    cartItems: []
  },
  auth: {
    authStatus: {
      indication: null,
      error: {
        status: null,
        message: null
      }
    },
    currentUser: null
  },
  checkout: {
    checkoutStatus: {
      indication: null,
      error: {
        status: null,
        message: null
      }
    }
  }
};

const bootState = localStorage["low-store"]
  ? JSON.parse(localStorage["low-store"])
  : initialState;

const appReducer = combineReducers({
  cart: cartReducer,
  auth: authReducer,
  checkout: checkoutReducer,
  ui: uiReducer,
  contact: contactReducer
});

let middleware = [
  thunk.withExtraArgument({
    api: createAPIClient({
      baseURL: process.env.REACT_APP_API_BASE_URL
    })
  }),
  tokenMiddleware
];

if (isDev) {
  middleware = [...middleware, createLogger()];
}

const store = createStore(
  appReducer,
  bootState,
  applyMiddleware(...middleware)
);

store.subscribe(() => {
  localStorage["low-store"] = JSON.stringify(store.getState(), null, 2);
});

export default store;



// WEBPACK FOOTER //
// ./src/redux/store.js